<template>
  <header id="header">
    <div class="container-ifgo">
      <div class="top2o">
        <b-navbar toggleable="lg" type="light">
          <b-navbar-brand href="#"
            ><router-link :to="{ name: 'home' }" class="navbar-brand"><img
              src="@/assets/imgs/layout/ifgoiano-horizontal-preto.svg"
              alt="Logo do IF Goiano"
          /></router-link></b-navbar-brand>

          <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>

          <b-collapse id="nav-collapse" is-nav>
            <b-navbar-nav>
              <b-nav-item to="/#evento">O evento</b-nav-item>
              <b-nav-item to="/#palestrantes">Palestrantes</b-nav-item>
              <b-nav-item to="/#maratona">Maratona</b-nav-item>
              <b-nav-item to="/#games">Games</b-nav-item>
              <b-nav-item to="/#programacao">Programação</b-nav-item>
              <b-nav-item to="/#local">Local</b-nav-item>
               <b-nav-item-dropdown text="Submissões" right>
                <b-dropdown-item href="#/submissoes">Chamada de trabalhos</b-dropdown-item>
                <b-dropdown-item href="http://enati.ifgoiano.edu.br" target="_blank">Anos anteriores</b-dropdown-item>
              </b-nav-item-dropdown>
              <b-nav-item
                href="https://eventos.ifgoiano.edu.br/enati2022/"
                class="destaque"
                target="_blank"
                >Inscreva-se</b-nav-item
              >
            </b-navbar-nav>

            <!-- Right aligned nav items -->
          </b-collapse>
        </b-navbar>

        <!-- <img
          src="@/assets/imgs/layout/ifgoiano-horizontal-preto.svg"
          alt="Logo do Campus Iporá do Instituto Federal Goiano"
        />
        <Menu /> -->
      </div>

  
    </div>
  </header>
</template>

<script>
//import Menu from "./Menu";


export default {
  components: {
    // Menu,

  },
};
</script>

<style lang="scss">
header#header {
  padding-top: 20px;
    margin-bottom: 20px;
  
}

.topo {
  margin: 30px 0px;
  display: flex;
  overflow: hidden;
  justify-content: space-between;
  align-items: center;
}

nav ul {
  list-style: none;
  display: flex;
  gap: 10px;
  text-transform: uppercase;
  font-family: "Barlow";
  font-weight: 600;
  display: flex;
  align-items: center;
  text-align: center;
}

.navbar-light a.nav-link{
  color: #000;
}

nav ul li a {
  color: var(--corTexto);
  font-size: 15px;
}

nav ul li.destaque {
  background: linear-gradient(-60deg, #ff5858 0%, #f09819 100%);
  background-size:1px 150px;  
  padding: 7px 21px;
  border-radius: 46px;
        -webkit-transition: background .5s ease-out;  
    -moz-transition: background .5s ease-out;  
    -o-transition: background .5s ease-out;  
    transition: background .5s ease-out;  
}

nav ul li.destaque:hover {
  background-position:100px; 



  transition: 1s;
  padding: 7px 21px;
  border-radius: 46px;
}


nav ul li.destaque .nav-link{
  color: #fff!important;

}

.navbar-nav .dropdown-menu{
  border: none!important;
  border-radius: 15px;
  box-shadow: 0 5px 20px -10px rgba(69,67,96,.35)!important;
  padding: 1rem;
  .dropdown-item{
    border-radius: 10px;
  }
}

.navbar-expand-lg .navbar-collapse {
  justify-content: flex-end;
}

.nav-link {
  padding: 0.2rem 0.5rem !important;
}
</style>
